import { BrowserRouter, Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./components/Home";
import LoginForm from "./components/login/LoginForm";
import TasksViewer from "./pages/TasksViewer";
import Header from "./pages/Header";
import About from "./pages/About";
import Contact from "./pages/Contact";

import { AuthContext } from "./context/AuthContext";
import { useAutoLogout } from "./hooks/useAutoLogout";

import AdminDashboard from "./pages/AdminDashboard";
import ScrollToTopButton from "./components/ScrollToTopButton";
import DictionaryPage from "./pages/DictionaryPage";

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
    const { token } = useContext(AuthContext);
    const location = useLocation();
    return token ? (
        children
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    );
};


const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const { handleLogin } = useContext(AuthContext);

    const onLogin = (token) => {
        handleLogin(token);
        navigate(from, { replace: true });
    };

    return <LoginForm onLogin={onLogin} />;
};


const App = () => {
    const { token, role, handleLogout } = useContext(AuthContext);
    useAutoLogout();

    return (
        <BrowserRouter>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                style={{ zIndex: 10000 }}
            />

            {token ? (
                <div className="flex flex-col min-h-screen pt-8">
                    <Header handleLogout={handleLogout} />
                    <div className="">
                        <Routes>
                            <Route
                                path="/"
                                element={
                                    <ProtectedRoute>
                                        <TasksViewer role={role} />
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />

                            <Route
                                path="/md-editor/:taskid"
                                element={
                                    <ProtectedRoute>
                                        <Home />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/about"
                                element={
                                    <ProtectedRoute>
                                        <About />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/contact"
                                element={
                                    <ProtectedRoute>
                                        <Contact />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/dictionary"
                                element={
                                    <ProtectedRoute>
                                        <DictionaryPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/login" element={<Navigate to="/" replace />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </div>
                </div>

            ) : (
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            )}
            <ScrollToTopButton />
        </BrowserRouter>

    );
};

export default App;
